export const mockFuelAverages = {
  fuelAverages: [
    {
      id: 1,
      fuelAverageCode: "MONTHMON",
      fuelAverageDescription:
        "Last Diesel Monday of Month Effective Following Month",
      effectiveDate: "11/01/2025",
      currentPrice: "3.868",
    },
    {
      id: 2,
      fuelAverageCode: "MONTHWED",
      fuelAverageDescription: "First Diesel Average of Mon Effective Wednesday",
      effectiveDate: "11/05/2025",
      currentPrice: "3.868",
    },
    {
      id: 3,
      fuelAverageCode: "MONTHWEDW",
      fuelAverageDescription: "PaddV Average of Monday Effective Wednesday",
      effectiveDate: "11/05/2025",
      currentPrice: "4.559",
    },
    {
      id: 4,
      fuelAverageCode: "National",
      fuelAverageDescription: "National Fuel Average Effective Wednesday",
      effectiveDate: "11/19/2025",
      currentPrice: "3.868",
    },
    {
      id: 5,
      fuelAverageCode: "NEXTMON",
      fuelAverageDescription: "Nati Diesel Average Effective Following Monday",
      effectiveDate: "11/24/2025",
      currentPrice: "3.868",
    },
    {
      id: 6,
      fuelAverageCode: "NEXTTUES",
      fuelAverageDescription: "Nati Diesel Average Effective Following Tuesday",
      effectiveDate: "11/25/2025",
      currentPrice: "3.868",
    },
    {
      id: 7,
      fuelAverageCode: "NEXTTUESW",
      fuelAverageDescription: "PADDV Average Effective Following Tuesday",
      effectiveDate: "11/25/2025",
      currentPrice: "3.868",
    },
    {
      id: 8,
      fuelAverageCode: "NEXTWED",
      fuelAverageDescription:
        "Nati Diesel Average Effective Following Wednesday",
      effectiveDate: "11/26/2025",
      currentPrice: "3.868",
    },
    {
      id: 9,
      fuelAverageCode: "WEEKLY",
      fuelAverageDescription: "Weekly Fuel Average Effective Monday",
      effectiveDate: "11/18/2025",
      currentPrice: "3.925",
    },
    {
      id: 10,
      fuelAverageCode: "MONTHLY",
      fuelAverageDescription: "Monthly Fuel Average Effective First of Month",
      effectiveDate: "11/01/2025",
      currentPrice: "3.842",
    },
    {
      id: 11,
      fuelAverageCode: "QUARTERLY",
      fuelAverageDescription:
        "Quarterly Fuel Average Effective First of Quarter",
      effectiveDate: "10/01/2025",
      currentPrice: "3.756",
    },
    {
      id: 12,
      fuelAverageCode: "ANNUAL",
      fuelAverageDescription: "Annual Fuel Average Effective January 1",
      effectiveDate: "1/01/2025",
      currentPrice: "3.689",
    },
    {
      id: 13,
      fuelAverageCode: "REGIONAL",
      fuelAverageDescription: "Regional Fuel Average Effective Wednesday",
      effectiveDate: "11/20/2025",
      currentPrice: "3.912",
    },
  ],
  pagination: {
    totalRecords: 13,
    totalPages: 2,
    currentPage: 1,
    pageSize: 10,
  },
};

export const mockFuelAverageHistory = {
  1: {
    // MONTHMON history - Extended with 20+ records for pagination testing
    success: true,
    message: null,
    errorCode: null,
    item: {
      id: 1,
      fuelAverageCode: "MONTHMON",
      description: "Last Diesel Monday of Month Effective Following Month",
      history: [
        {
          effectiveDate: "11/01/2025",
          price: "3.868",
          modifiedBy: "John Smith",
          modifiedDate: "10/25/2025",
        },
        {
          effectiveDate: "10/01/2025",
          price: "3.756",
          modifiedBy: "Jane Doe",
          modifiedDate: "09/24/2025",
        },
        {
          effectiveDate: "09/01/2025",
          price: "3.842",
          modifiedBy: "Bob Johnson",
          modifiedDate: "08/28/2025",
        },
        {
          effectiveDate: "08/01/2025",
          price: "3.925",
          modifiedBy: "Alice Williams",
          modifiedDate: "07/29/2025",
        },
        {
          effectiveDate: "07/01/2025",
          price: "3.712",
          modifiedBy: "Carlos Mendez",
          modifiedDate: "06/26/2025",
        },
        {
          effectiveDate: "06/01/2025",
          price: "3.889",
          modifiedBy: "Emily Davis",
          modifiedDate: "05/28/2025",
        },
        {
          effectiveDate: "05/01/2025",
          price: "3.934",
          modifiedBy: "David Lee",
          modifiedDate: "04/25/2025",
        },
        {
          effectiveDate: "04/01/2025",
          price: "3.801",
          modifiedBy: "Maria Garcia",
          modifiedDate: "03/27/2025",
        },
        {
          effectiveDate: "03/01/2025",
          price: "3.678",
          modifiedBy: "James Wilson",
          modifiedDate: "02/26/2025",
        },
        {
          effectiveDate: "02/01/2025",
          price: "3.956",
          modifiedBy: "Linda Martinez",
          modifiedDate: "01/29/2025",
        },
        {
          effectiveDate: "01/01/2025",
          price: "3.823",
          modifiedBy: "Robert Taylor",
          modifiedDate: "12/27/2024",
        },
        {
          effectiveDate: "12/01/2024",
          price: "3.745",
          modifiedBy: "Patricia Anderson",
          modifiedDate: "11/26/2024",
        },
        {
          effectiveDate: "11/01/2024",
          price: "3.892",
          modifiedBy: "Michael Thomas",
          modifiedDate: "10/28/2024",
        },
        {
          effectiveDate: "10/01/2024",
          price: "3.967",
          modifiedBy: "Jennifer Jackson",
          modifiedDate: "09/26/2024",
        },
        {
          effectiveDate: "09/01/2024",
          price: "3.834",
          modifiedBy: "William White",
          modifiedDate: "08/29/2024",
        },
        {
          effectiveDate: "08/01/2024",
          price: "3.701",
          modifiedBy: "Elizabeth Harris",
          modifiedDate: "07/30/2024",
        },
        {
          effectiveDate: "07/01/2024",
          price: "3.856",
          modifiedBy: "Joseph Martin",
          modifiedDate: "06/27/2024",
        },
        {
          effectiveDate: "06/01/2024",
          price: "3.923",
          modifiedBy: "Susan Thompson",
          modifiedDate: "05/29/2024",
        },
        {
          effectiveDate: "05/01/2024",
          price: "3.789",
          modifiedBy: "Charles Garcia",
          modifiedDate: "04/26/2024",
        },
        {
          effectiveDate: "04/01/2024",
          price: "3.812",
          modifiedBy: "Nancy Martinez",
          modifiedDate: "03/28/2024",
        },
        {
          effectiveDate: "03/01/2024",
          price: "3.945",
          modifiedBy: "Daniel Robinson",
          modifiedDate: "02/27/2024",
        },
        {
          effectiveDate: "02/01/2024",
          price: "3.678",
          modifiedBy: "Karen Clark",
          modifiedDate: "01/30/2024",
        },
        {
          effectiveDate: "01/01/2024",
          price: "3.734",
          modifiedBy: "Matthew Rodriguez",
          modifiedDate: "12/28/2023",
        },
      ],
      pagination: {
        totalRecords: 23,
        totalPages: 5,
        currentPage: 1,
        pageSize: 5,
      },
    },
  },
  2: {
    // MONTHWED history - Extended with more records
    success: true,
    message: null,
    errorCode: null,
    item: {
      id: 2,
      fuelAverageCode: "MONTHWED",
      description: "First Diesel Average of Mon Effective Wednesday",
      history: [
        {
          effectiveDate: "11/05/2025",
          price: "3.868",
          modifiedBy: "Sarah Miller",
          modifiedDate: "10/30/2025",
        },
        {
          effectiveDate: "10/05/2025",
          price: "3.789",
          modifiedBy: "Michael Brown",
          modifiedDate: "09/28/2025",
        },
        {
          effectiveDate: "09/05/2025",
          price: "3.856",
          modifiedBy: "Jessica Moore",
          modifiedDate: "08/30/2025",
        },
        {
          effectiveDate: "08/05/2025",
          price: "3.912",
          modifiedBy: "Christopher Taylor",
          modifiedDate: "07/31/2025",
        },
        {
          effectiveDate: "07/05/2025",
          price: "3.745",
          modifiedBy: "Ashley Anderson",
          modifiedDate: "06/29/2025",
        },
        {
          effectiveDate: "06/05/2025",
          price: "3.823",
          modifiedBy: "Joshua Thomas",
          modifiedDate: "05/30/2025",
        },
        {
          effectiveDate: "05/05/2025",
          price: "3.901",
          modifiedBy: "Amanda Jackson",
          modifiedDate: "04/29/2025",
        },
        {
          effectiveDate: "04/05/2025",
          price: "3.678",
          modifiedBy: "Ryan White",
          modifiedDate: "03/30/2025",
        },
        {
          effectiveDate: "03/05/2025",
          price: "3.934",
          modifiedBy: "Stephanie Harris",
          modifiedDate: "02/27/2025",
        },
        {
          effectiveDate: "02/05/2025",
          price: "3.812",
          modifiedBy: "Brandon Martin",
          modifiedDate: "01/31/2025",
        },
        {
          effectiveDate: "01/05/2025",
          price: "3.756",
          modifiedBy: "Nicole Thompson",
          modifiedDate: "12/30/2024",
        },
        {
          effectiveDate: "12/05/2024",
          price: "3.889",
          modifiedBy: "Kevin Garcia",
          modifiedDate: "11/29/2024",
        },
        {
          effectiveDate: "11/05/2024",
          price: "3.967",
          modifiedBy: "Lauren Martinez",
          modifiedDate: "10/30/2024",
        },
      ],
      pagination: {
        totalRecords: 13,
        totalPages: 3,
        currentPage: 1,
        pageSize: 5,
      },
    },
  },
};
